import { Button, Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import { HeaderBackButtonMui } from 'src/components/header/HeaderBackButtonMui'

type Props = {
  onBack: () => void
  onSave: () => void
  canSave: boolean
}

export const Header: FC<Props> = ({ onBack, onSave, canSave }) => {
  return (
    <Stack
      sx={{
        height: 72,
        minHeight: 72,
        px: 3,
        bgcolor: 'white',
        boxShadow: 'none',
        borderBottom: 1,
        borderColor: 'divider',
      }}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <HeaderBackButtonMui onClick={onBack} sx={{ fontWeight: 'bold' }} />
        <Typography
          variant="h1"
          sx={{
            color: 'text.primary',
            fontWeight: 'bold',
            fontSize: '20px',
            ml: 1,
          }}
        >
          バーコード設定
        </Typography>
      </Stack>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        disabled={!canSave}
        onClick={onSave}
        sx={{ fontWeight: 'bold' }}
      >
        保存
      </Button>
    </Stack>
  )
}
